export class UpdateProfileAction {
  static readonly type = '[AppBloks] Login';
  constructor(public profile: any) {}
}

export class LogoutAction {
  static readonly type = '[AppBloks] Logout';
  constructor() {}
}
